import axios from 'axios';
import { notifyUnauthorized } from './authEvents';

// Ask Sinatra: a question in plain words, and what it finds
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) notifyUnauthorized();
    return Promise.reject(error);
  }
);

const toError = (error) => {
  const detail = error.response?.data?.detail;
  return new Error(typeof detail === 'string' ? detail : "Sinatra couldn't answer that; try again");
};

const askApi = {
  // filters: the ones in use, so a follow-up question can build on them
  async ask(message, filters) {
    try {
      const { data } = await apiClient.post('/api/v2/ask', { message, filters: filters || null });
      return data;
    } catch (error) {
      throw toError(error);
    }
  },

  // The same search without the model: another page, or with a filter removed
  async results(filters, page = 1) {
    try {
      const { data } = await apiClient.post('/api/v2/ask/results', { filters, page });
      return data;
    } catch (error) {
      throw toError(error);
    }
  }
};

export default askApi;
